export const MAX_CHARS_COMMUNITY_DESCRIPTION = 7000;
export const MIN_CHARS_COMMUNITY_DESCRIPTION = 10;
